<template>
  <span class="c-shortcut inline-flex items-center gap-2">
    <slot />
  </span>
</template>

<script lang="ts" setup>
import useThemeVars from '@lib/composables/useThemeVars'

const themeVars = useThemeVars()
</script>

<style lang="scss" scoped>
.c-shortcut {
  color: v-bind('themeVars.text2');
}
</style>
